import { render, staticRenderFns } from "./DonationChart.vue?vue&type=template&id=3df198d2&scoped=true&lang=pug&"
import script from "./DonationChart.vue?vue&type=script&lang=js&"
export * from "./DonationChart.vue?vue&type=script&lang=js&"
import style0 from "./DonationChart.vue?vue&type=style&index=0&id=3df198d2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df198d2",
  null
  
)

/* custom blocks */
import block0 from "./DonationChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow,VSelect})
